import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bc6dea98&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=bc6dea98&prod&lang=stylus"
import style1 from "./index.vue?vue&type=style&index=1&id=bc6dea98&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6dea98",
  null
  
)

export default component.exports